const gql = {
  query: `query unifiedgraph {
    getBankList {
      success
      messages {
        errorCode
        errorMessage
        errorSeverity
      }
      data {
        customerProfile {
          name
        }
        taAccounts {
          allowAddBank,
          bankList {
            allowDelete
            deleteBank
            hasSystematic
            textData {
              accountType
              registrationLine1
              registrationLine2
              registrationLine3
              bankName
              bankAccountNumber
            }
            formData
          }
        }
        tracAccounts {
          allowAddBank,
          bankList {
            allowDelete
            deleteBank
            hasSystematic
            textData {
              accountType
              registrationLine1
              registrationLine2
              registrationLine3
              bankName
              bankAccountNumber
            }
            formData
          }
        }
      }
    }
  }`,
  meta: {
    label: "Get Bank List",
  },
};

export default gql;
